import { CreateQuizSelection, CreateQuizType } from './create-quiz.models';

export const isStartQuizEnabled = (selection: CreateQuizSelection, hasError: boolean): boolean => {
  if (hasError || !selection || !selection.quizType) {
    return false;
  }
  if (selection.isQuestionBankRequired && !selection.questionBankIsbn) {
    return false;
  }

  const topicCount = selection.topicIds ? selection.topicIds.length : 0;

  switch (selection.quizType) {
    case CreateQuizType.MASTERY:
      return topicCount === 1 && !!selection.masteryGoal;
    case CreateQuizType.CUSTOM:
      return topicCount >= 1 && selection.questionCount > 0;
    case CreateQuizType.NGN_CASE_STUDY:
      return topicCount === 1;
    default:
      return false;
  }
};
